import React, { useRef } from 'react'
import ReactDOM from 'react-dom'
import { CSSTransition } from 'react-transition-group'
import Backdrop from './Backdrop'
import './PasswordModal.css'

const PasswordModalOverlay = (props) => {
	const content = (
		<div className={`pmodal ${props.className}`} style={props.style}>
			<header className={`pmodal__header ${props.headerClass}`}>
				<h2>{props.header}</h2>
			</header>
			<form
				onSubmit={
					props.onSubmit ? props.onSubmit : (event) => event.preventDefault()
				}
			>
				<div className={`pmodal__content ${props.contentClass}`}>
					{props.children}
				</div>
				<footer className={`pmodal__footer ${props.footerClass}`}>
					{props.footer}
				</footer>
			</form>
		</div>
	)
	return ReactDOM.createPortal(content, document.getElementById('modal-hook'))
}

const PasswordModal = (props) => {
	const nodeRef = useRef(null)

	return (
		<React.Fragment>
			{props.show && <Backdrop onClick={props.onCancel} />}
			<CSSTransition
				in={props.show}
				mountOnEnter
				unmountOnExit
				timeout={200}
				className='pmodal'
				nodeRef={nodeRef}
			>
				<PasswordModalOverlay {...props} />
			</CSSTransition>
		</React.Fragment>
	)
}

export default PasswordModal
